import { useMsal } from '@azure/msal-react';
import { getRoles, checkRole } from '../../utils/RoleUtils';

var HasRoles = function HasRoles(_ref) {
  var roles = _ref.roles,
      children = _ref.children;

  var _useMsal = useMsal(),
      instance = _useMsal.instance;

  if (checkRole(getRoles(instance), roles)) {
    return children;
  }

  return null;
};

export default HasRoles;